import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=bd631ae0&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"
import style0 from "./Article.vue?vue&type=style&index=0&id=bd631ae0&prod&lang=scss&scoped=true"
import style1 from "./Article.vue?vue&type=style&index=1&id=bd631ae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd631ae0",
  null
  
)

export default component.exports